<mat-form-field appearance="outline">
  <mat-label>{{ label() }}</mat-label>

  <mat-select [formControl]="control()" [(value)]="defaultValue">
    @if (value.length > 0) {
      @for (option of defaultOptions(); track $index) {
        <mat-option [value]="option[value()]">
          {{ option[labelSelect()] }}
        </mat-option>
        <hr />
      }
    } @else {
      @for (option of defaultOptions(); track $index) {
        <mat-option [value]="option">
          {{ option[labelSelect()] }}
        </mat-option>
        <hr />
      }
    }
  </mat-select>
</mat-form-field>
